module.exports = __webpack_public_path__ + "static/media/n8n_io_ai.e45d8099.png";